import { typedAction } from './common/actions';
import { RootState } from '../redux/reducers';

export interface MessagesState {
  isPublicPostOpenedFromEditor: boolean;
  isPopupOpenedFromEditor: boolean;
  isClosedByHighlightPostFeature: boolean;
  isPopupClosed: boolean;
  isPopupLoaded: boolean;
  embedUrl?: string;
  didPaginate?: boolean;
  isEmbedVisible?: boolean;
  isAnalyticsLoaded?: boolean;
}
const initialState: MessagesState = {
  isPublicPostOpenedFromEditor: false,
  isPopupOpenedFromEditor: false,
  isClosedByHighlightPostFeature: false,
  isPopupClosed: false,
  isPopupLoaded: false,
  embedUrl: undefined,
  didPaginate: false,
  isEmbedVisible: false,
  isAnalyticsLoaded: false,
};

export const UPDATE = 'messages/update';

export interface IUpdateMessagesPayload {
  key: keyof MessagesState;
  value: boolean;
}

export const updateMessages = (payload: IUpdateMessagesPayload) => {
  return typedAction(UPDATE, payload);
};

type MessagesAction = ReturnType<typeof updateMessages>;
export function messagesReducer(state = initialState, action: MessagesAction): MessagesState {
  switch (action.type) {
    case UPDATE:
      const newState = { ...state, [action.payload.key]: action.payload.value };
      return newState;
    default:
      return state;
  }
}

export const selectIsPublicPostOpenedFromEditor = (state: RootState) => state.messages.isPublicPostOpenedFromEditor;

export const selectIsPopupOpenedFromEditor = (state: RootState) => state.messages.isPopupOpenedFromEditor;

export const selectIsClosedByHighlightPostFeature = (state: RootState) => state.messages.isClosedByHighlightPostFeature;

export const selectIsPopupClosed = (state: RootState) => state.messages.isPopupClosed;

export const selectIsPopupLoaded = (state: RootState) => state.messages.isPopupLoaded;

export const selectEmbedUrl = (state: RootState) => state.messages.embedUrl;

export const selectdidPaginate = (state: RootState) => state.messages.didPaginate;

export const selectIsEmbedVisible = (state: RootState) => state.messages.isEmbedVisible;

export const selectIsAnalyticsLoaded = (state: RootState) => state.messages.isAnalyticsLoaded;
